import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Cell,
} from "recharts";



const getBarColor = (growth) => {
  if (growth === null || growth === undefined) return "#9CA3AF"; // gray
  if (growth >= 0) return "#22C55E"; // green
  return "#EF4444"; // red
};

const TodaysSalesSalesperson = ({ endpoint }) => {


  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"

  const [trendData, setTrendData] = useState(null)
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState([]);
  const [selectedBranchCode, setSelectedBranchCode] = useState([]);

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  const todayDate = getTodayDate();

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await axios.get(
          `https://cubixweberp.com:213/api/MasterCount/${company_code_from_local_storage}/BRANCH/ADMIN/-`
        );
        const data = response.data;
        const branchArray = Array.isArray(data) ? data : [data];
        console.log('branchArray', branchArray)
        setBranches(branchArray);

        // Automatically select the first branch
        if (branchArray.length > 0) {
          //   setSelectedBranch(branchArray[0].DEPTNO);
          setSelectedBranch(branchArray[0]);
        }
      } catch (error) {
        console.error("Failed to fetch branches", error);
      }
    };

    fetchBranches();
  }, []);

  useEffect(() => {
    console.log('selectedBranch', selectedBranch)
    if (selectedBranch) {
      fetchTrendData(selectedBranch);
    }
  }, [selectedBranch]);


  useEffect(() => {
    console.log('selectedbranchCode', selectedBranchCode)

    const selected = branches?.find(
      (branch) => branch.DEPTNO === selectedBranchCode
    );
    setSelectedBranch(selected);
    console.log('selected', selected)
  }, [selectedBranchCode])

  const fetchTrendData = async (selectedBranch) => {
    try {
      const response = await axios.get(
        `https://cubixweberp.com:213/api/HRDashboard/${company_code_from_local_storage}/${selectedBranch.DEPTNO}/${endpoint}/2024-01-01/${todayDate}/-/-/-/-/-`
      );
      const data = response.data || [];

      console.log("data >>. todays", data)
      setTrendData(data);
    } catch (err) {
      console.error("Error while fetching financial data", err);
    }
  }


  return (
    <div className="w-full h-[300px] rounded px-4">


      <div className="flex justify-between items-center mb-2">
        <div className="flex justify-left gap-4 items-center mb-2">

          {selectedBranch && (
            <div className="mt-2 text-sm text-gray-700">
              Selected Branch:{" "}
              <strong>
                {selectedBranch.deptnodesc} ({selectedBranch.DEPTNO})
              </strong>
            </div>
          )}
        </div>

        <select
          value={selectedBranch?.DEPTNO || ""}
          onChange={(e) => setSelectedBranchCode(e.target.value)}
          className="border border-gray-300 rounded px-2 py-1 text-sm"
        >
          {branches?.map((branch) => (
            <option key={branch.DEPTNO} value={branch.DEPTNO}>
              {branch.deptnodesc}
            </option>
          ))}
        </select>
      </div>

      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={trendData} >
          {/* <XAxis dataKey="SaleMonth" /> */}
          <XAxis
            dataKey="Salesman"
            angle={-30}
            textAnchor="end"
            interval={0}
            style={{ fontSize: '10px' }}
            dy={2}
          />

          <YAxis style={{ fontSize: '12px' }} />
          <Tooltip
            formatter={(value, name) => [`₹${value.toLocaleString()}`, name]}
            labelFormatter={(label) => `Month: ${label}`}
          />
          {/* <CartesianGrid strokeDasharray="3 3" /> */}
          <Bar dataKey="NetAmount" name="Net Amount">
            {trendData?.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={getBarColor(entry.GrowthPercent)}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TodaysSalesSalesperson;